<template>
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div
                    class="row g-4 align-items-center p-4 bg-white shadow-sm border-bottom border-danger border-5"
                >
                    <!-- Text Section -->
                    <div class="col-12">
                        <h1 class="mb-5">You're all set!</h1>

                        <p class="mb-4">
                            <strong>You can now login to continue your journey.</strong>
                        </p>

                        <p class="mb-4">

                            <a href="/login" button class="btn btn-primary btn-calltoaction" >
                             <span class="bl-submit-text">Log in to your account</span>
                            </a>
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


